module.exports = __webpack_public_path__ + "img/UTKODA-18.ce8c21ba.jpg";